import classify from "./array-classify";

export default (array, groupBy) => {
    const grouped = classify(
        array,
        (a, b) => {
            return a[groupBy][0].toLowerCase() === b[groupBy][0].toLowerCase();
        }
    );

    return grouped;
};
